<template>
	<div class="consent-placeholder" role="note">
		<p class="consent-placeholder__text">{{ texts.text }}</p>
		<div class="consent-placeholder__actions">
			<button type="button" class="consent-placeholder__button" @click="allowExternal()">{{ texts.allow }}</button>
			<button type="button" class="consent-placeholder__link" @click="openPreferences()">{{ texts.settings }}</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed, PropType} from "vue";
import {allowExternal, EmbedKind, openPreferences, placeholderTexts} from "../../Utils/Consent";

/**
 * The place of an external embed (map, video) until the visitor allows the external content.
 */
const props = defineProps({
	kind: {
		type: String as PropType<EmbedKind>,
		default: 'content',
	},
});

const texts = computed(() => placeholderTexts(props.kind));
</script>
